module.exports = __webpack_public_path__ + "media/images/prizes__first-ae0a39572e2a99d50fab157922c5e84c.jpg";